import React from 'react';

const WhatsAppButton: React.FC = () => {
  return (
    <div className="whatsapp-button-container">
      <a 
        href="https://wa.me/5491133102465" 
        className="whatsapp-button" 
        target="_blank" 
        rel="noopener noreferrer"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#25D366',
          color: 'white',
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          textDecoration: 'none',
          boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
          fontSize: '24px',
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 1000,
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.3)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.2)';
        }}
      >
        <i className="fab fa-whatsapp" style={{ marginRight: 0 }}></i>
      </a>
    </div>
  );
};

export default WhatsAppButton;
